import { useDispatch } from "react-redux";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { ProjectEnum } from "../../../../models/common/Enums";
import { GetCountryListResponseData } from "../../../../models/response/country/GetCountryListResponse";
import { ConstantService } from "../../../../services/ConstantService";
import { ProjectRegionService } from "../../../../services/ProjectRegionService";
import { storeActivityIndicator } from "../../../../redux/reducers/authSlice";
import { GetProjectRegionListResponse } from "../../../../models/response/projectRegion/GetProjectRegionListResponse";
import toast from "react-hot-toast";

interface Props {
    locationInformationRef: any
    trCountry: GetCountryListResponseData | undefined
    selectedLoadingCounty: CustomSingleSelectModel | undefined
    setSelectedLoadingCounty: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedLoadingDistrict: CustomSingleSelectModel | undefined
    setSelectedLoadingDistrict: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedLoadingNeighborhood: CustomSingleSelectModel | undefined
    setSelectedLoadingNeighborhood: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliverCounty: CustomSingleSelectModel | undefined
    setSelectedDeliverCounty: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliverDistrict: CustomSingleSelectModel | undefined
    setSelectedDeliverDistrict: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliverNeighborhood: CustomSingleSelectModel | undefined
    setSelectedDeliverNeighborhood: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedLoadingRegion: CustomSingleSelectModel | undefined
    setSelectedLoadingRegion: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliverRegion: CustomSingleSelectModel | undefined
    setSelectedDeliverRegion: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedCarryType: CustomSingleSelectModel | undefined
}

const LocationInformation = ({
    locationInformationRef,
    trCountry,
    selectedDeliverCounty,
    selectedDeliverDistrict,
    selectedDeliverNeighborhood,
    selectedDeliverRegion,
    selectedLoadingCounty,
    selectedLoadingDistrict,
    selectedLoadingNeighborhood,
    selectedLoadingRegion,
    setSelectedDeliverCounty,
    setSelectedDeliverDistrict,
    setSelectedDeliverNeighborhood,
    setSelectedDeliverRegion,
    setSelectedLoadingCounty,
    setSelectedLoadingDistrict,
    setSelectedLoadingNeighborhood,
    setSelectedLoadingRegion,
    selectedCarryType
}: Props) => {
    const dispatch = useDispatch();

    const onLoadingNeighborhoodChange = async (_selectedValue: CustomSingleSelectModel | undefined) => {
        // Semt seçimi yalnız alanı günceller. Başlangıç bölgesi sipariş ekranındaki
        // ortak tetikleyiciden bulunur; o tetikleyici taşıma yöntemi ile il, ilçe ve
        // semt değişimlerinin hepsini birlikte izliyor.
        setSelectedLoadingNeighborhood(_selectedValue);
    }

    const onDeliverNeighborhoodChange = async (_selectedValue: CustomSingleSelectModel | undefined) => {
        // Bitiş bölgesi de ortak tetikleyiciden bulunur.
        setSelectedDeliverNeighborhood(_selectedValue);
    }

    return (
        <div className='containerPart' ref={locationInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Lokasyon Bilgileri</h4>

                    <div className="row">
                        <div className="col-md-3">
                            <CustomSingleSelect
                                labelText="Yükleme İl"
                                selectedValue={selectedLoadingCounty}
                                onChange={(selectedItem) => {
                                    setSelectedLoadingCounty(selectedItem);
                                    setSelectedLoadingDistrict(undefined);
                                    setSelectedLoadingNeighborhood(undefined);
                                    setSelectedLoadingRegion(undefined);
                                }}
                                onMenuOpen={trCountry ? () => ConstantService.getConstantList('COUNTY', trCountry.countryId) : undefined}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-3">
                            <CustomSingleSelect
                                labelText="Yükleme İlçe"
                                selectedValue={selectedLoadingDistrict}
                                onChange={(selectedItem) => {
                                    setSelectedLoadingDistrict(selectedItem);
                                    setSelectedLoadingNeighborhood(undefined);
                                    setSelectedLoadingRegion(undefined);
                                }}
                                onMenuOpen={selectedLoadingCounty ? () => ConstantService.getConstantList('DISTRICT', selectedLoadingCounty.value) : undefined}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-3">
                            <CustomSingleSelect
                                labelText="Yükleme Semt"
                                selectedValue={selectedLoadingNeighborhood}
                                onChange={onLoadingNeighborhoodChange}
                                onMenuOpen={selectedLoadingDistrict ? () => ConstantService.getConstantList('NEIGHBORHOOD', selectedLoadingDistrict.value) : undefined}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-3">
                            <CustomSingleSelect
                                labelText="Yükleme Bölgesi"
                                selectedValue={selectedLoadingRegion}
                                onChange={setSelectedLoadingRegion}
                                onMenuOpen={((selectedLoadingCounty && selectedLoadingDistrict && selectedLoadingNeighborhood) ? () => ProjectRegionService.getProjectRegionList(selectedLoadingCounty, selectedLoadingDistrict, selectedLoadingNeighborhood, selectedCarryType ? [selectedCarryType] : undefined, { label: '', value: '', additionalValue1: ProjectEnum.AMBAR }) : undefined)}
                                labelName='regionName'
                                valueName='regionId'
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-3">
                            <CustomSingleSelect
                                labelText="Teslim İl"
                                selectedValue={selectedDeliverCounty}
                                onChange={(selectedItem) => {
                                    setSelectedDeliverCounty(selectedItem);
                                    setSelectedDeliverDistrict(undefined);
                                    setSelectedDeliverNeighborhood(undefined);
                                    setSelectedDeliverRegion(undefined);
                                }}
                                onMenuOpen={trCountry ? () => ConstantService.getConstantList('COUNTY', trCountry.countryId) : undefined}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-3">
                            <CustomSingleSelect
                                labelText="Teslim İlçe"
                                selectedValue={selectedDeliverDistrict}
                                onChange={(selectedItem) => {
                                    setSelectedDeliverDistrict(selectedItem);
                                    setSelectedDeliverNeighborhood(undefined);
                                    setSelectedDeliverRegion(undefined);
                                }}
                                onMenuOpen={selectedDeliverCounty ? () => ConstantService.getConstantList('DISTRICT', selectedDeliverCounty.value) : undefined}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-3">
                            <CustomSingleSelect
                                labelText="Teslim Semt"
                                selectedValue={selectedDeliverNeighborhood}
                                onChange={onDeliverNeighborhoodChange}
                                onMenuOpen={selectedDeliverDistrict ? () => ConstantService.getConstantList('NEIGHBORHOOD', selectedDeliverDistrict.value) : undefined}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>

                        <div className="col-md-3">
                            <CustomSingleSelect
                                labelText="Teslim Bölgesi"
                                selectedValue={selectedDeliverRegion}
                                onChange={setSelectedDeliverRegion}
                                onMenuOpen={((selectedDeliverCounty && selectedDeliverDistrict && selectedDeliverNeighborhood) ? () => ProjectRegionService.getProjectRegionList(selectedDeliverCounty, selectedDeliverDistrict, selectedDeliverNeighborhood, selectedCarryType ? [selectedCarryType] : undefined, { label: '', value: '', additionalValue1: ProjectEnum.AMBAR }) : undefined)}
                                labelName='regionName'
                                valueName='regionId'
                            />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default LocationInformation;